import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { H1, H2, P, scrollToTop } from 'shared';
import OfferCard from '../components/OfferCard';
function MoreOffers({ offers }) {
    // If there are offers that are not prequalified, sort them so that the prequalified offers are at the top
    const sortedOffers = offers.some((offer) => offer.offerType !== 'prequalified')
        ? offers.slice().sort((a) => (a.offerType === 'prequalified' ? -1 : 1))
        : offers;
    useEffect(() => {
        scrollToTop();
    }, []);
    return (_jsxs("div", { className: "offers-container", style: { paddingTop: '20px' }, children: [_jsx(H1, { className: "mar-t-20", children: "Let\u2019s take a look at the other offers." }), _jsx(H2, { className: "mar-t-40", children: "Please see below your Alphaeon offer details" }), _jsx("div", { className: "mar-t-40", children: sortedOffers.map((offer) => (_jsx(OfferCard, { offer: offer }, offer.offerId))) }), offers.some((offer) => offer.offerType === 'prequalified' &&
                offer.serviceProviderName === 'ADS') && (_jsx("div", { className: "mar-t-40", children: _jsx(P, { className: "color-gray", children: "* The credit limit provided is based on your pre-qualification only, and upon submission of your full credit application, may be increased or decreased." }) }))] }));
}
export default MoreOffers;
